import { useQuery } from "@tanstack/vue-query";
import { toRef, toValue, type MaybeRefOrGetter } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";
import { V4HSiteId } from "@/data/common/ids";

export function useGetSiteSectionCategoriesQuery(siteId: MaybeRefOrGetter<V4HSiteId>) {
  const v4b = useServices().v4b.clientSdk;
  const _siteId = toRef(siteId);

  return useQuery({
    queryKey: SitesQueryKeys.sectionCategories(_siteId),
    queryFn: () => v4b.siteSectionCategory.findAll(toValue(_siteId)),
  });
}
